// src/store/pointsStore.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PointsState {
  points: number;
  syncEnabled: boolean;
  setPoints: (points: number) => void;
  resetPoints: () => void;
  setSyncEnabled: (enabled: boolean) => void;
}

export const usePointsStore = create<PointsState>()(
  persist(
    (set) => ({
      points: 0,
      syncEnabled: true,
      setPoints: (points) => set({ points }),
      resetPoints: () => set({ points: 0 }),
      setSyncEnabled: (enabled) => set({ syncEnabled: enabled })
    }),
    {
      name: 'points-storage'
    }
  )
);
